import styled from "styled-components";

export const LaneNameContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  color: ${({ theme }) => theme.editor.textLight};
  background-color: ${({ theme }) => theme.backgroundTag};
  margin: 5px 8px 5px 0;
  padding: 0 12px 0 0;
  border-radius: ${({ theme }) => theme.borderRadius};
  height: 24px;
  transition: all 0.2s ease-in-out;
  transition-property: transform, box-shadow;

  &&:hover {
    cursor: pointer;
    transform: scale(1.03);
    box-shadow: 1px 1px rgb(0, 0, 0, 0.2);
  }

  .lane-color-bubble {
    width: 24px;
    height: 24px;
    min-width: 24px;
    background-color: blue;
    border-radius: 50%;
    margin-right: 8px;
  }

  .lane-name {
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
